import * as React from 'react';
import { useSlate } from 'slate-react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { DisplayTextProps } from '@sdk/components/ui/DisplayTextStyle';
import DisplayText from '@sdk/components/ui/DisplayText';
import View from '@sdk/components/primitives/View';

import { CustomElementTypes } from '../types';
import { toggleBlock, isBlockActive } from '../helpers/utils';

import TextEditToolbarButton from './TextEditToolbarButton';

type Props = {
  format: CustomElementTypes;
  disableUnfocused?: boolean;
} & DisplayTextProps;

const MarkBlockTextButton: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  format,
  ...restProps
}) => {
  const editor = useSlate();
  const isActive = isBlockActive(editor, format);
  const themeColor = isActive ? ThemeColorType.white : ThemeColorType.iconGray;

  return (
    <View>
      <TextEditToolbarButton
        isActive={isActive}
        onMouseDown={(): void => toggleBlock(editor, format)}
        mRight={3}>
        <DisplayText fontSize={14} themeColor={themeColor} {...restProps}>
          {children}
        </DisplayText>
      </TextEditToolbarButton>
    </View>
  );
};

export default MarkBlockTextButton;
